
document.addEventListener("DOMContentLoaded", function () {
  AOS.init({
    duration: 1200,
  })
  
  // referral_code...
  const urlParams = new URLSearchParams(window.location.search);
  const referral = urlParams.get("referral");

  if (referral) {
    // document.cookie = `referral_code=${referral}; path=/`;
    localStorage.setItem("referral_code", referral);
  }
});




//menu drawer...
document.addEventListener('DOMContentLoaded', () => {
  const menuDrawer = document.querySelector('.menu-drawer__menu');
  if (!menuDrawer) return;

  //all links inside the drawer
  menuDrawer.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      const details = menuDrawer.closest('details[open]');
      const menuDrawerContainer = menuDrawer.closest('.menu-drawer-container');
      const summary = details.querySelector('summary');
      if (details) {
        details.removeAttribute('open');
        menuDrawerContainer.classList.remove('menu-opening');
      }
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
        document.body.classList.remove('overflow-hidden-tablet');
    });
  });
});


// video event...
document.querySelectorAll('.grootapps_video_demo').forEach((trigger) => {
  const id = trigger.dataset.videoId;
  const wrapper = document.querySelector(`.gapp_video-wrappper[data-video-id="${id}"]`);
  const closeBtn = wrapper?.querySelector('.gapp_video-close-btn');

  trigger.addEventListener('click', () => {
    wrapper?.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  closeBtn?.addEventListener('click', () => {
    wrapper?.classList.remove('active');
    document.body.style.overflow = '';
  });
});


// tabs slider...
new Swiper(".grootapps_sb_tab_container_wrap.mySwiper", {
    slidesPerView: "auto",
    centeredSlides: false,
    spaceBetween: 12,    
    breakpoints: {
        1300: {
            slidesPerView: 'auto',
            spaceBetween: 20
        }
    }
});


const tabs = document.querySelectorAll('.grootapps_sb_tabs_item');
const slides = document.querySelectorAll('.grootapps_sb-slider-item');
let swiperInstance = null;


initSwiper();

function initSwiper() {
  swiperInstance = new Swiper(".grootapps_sb_image_slider.mySwiper", {
      slidesPerView: 1,
      direction: 'horizontal',
      freeMode: false,
      centeredSlides: false,
      loop: false,
      spaceBetween: 15, 
      on: {
        init() {
          setInitialActiveTab();
        },
        slideChange() {
          syncActiveTab(swiperInstance.activeIndex);
        }
      },
      breakpoints: {
          400: {
              centeredSlides: true,
              slidesPerView: 1.1,
          },
          1100: {
              centeredSlides: true,
              slidesPerView: 'auto',
              spaceBetween: 20,
          }
      },
  });
}

// set first tab active on page load
function setInitialActiveTab() {
  if (!tabs.length) return;
  tabs[0].classList.add('active');
}

// sync tab when slide changes
function syncActiveTab(slideIndex) {
  const activeSlide = swiperInstance.slides[slideIndex];
  const activeTabKey = activeSlide.getAttribute('data-tab');

  tabs.forEach(tab => {
    tab.classList.toggle('active', tab.getAttribute('data-tab') === activeTabKey);
  });
}

// click event: go to matching slide & set tab active
tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const tabKey = tab.getAttribute('data-tab');

    const slideIndex = Array.from(swiperInstance.slides).findIndex(
      slide => slide.getAttribute('data-tab') === tabKey
    );

    if (slideIndex >= 0) {
      swiperInstance.slideTo(slideIndex);
    }

    tabs.forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
  });
});

// features JS...
const features = document.querySelectorAll('.grootapps-theme-setting-item');
  const themeImages = document.querySelectorAll('.grootapps-ts-image');
  const themeAccordionImages = document.querySelectorAll('.grootapps-ts-accordion-image');
  const accordionIconWrappers = document.querySelectorAll('.grootapps_ts-acoordion-icon-wrap');

  function showImageForTheme(title) {
    if (!themeImages || themeImages.length === 0) return;

    themeImages.forEach(theme => {
      const themeTitle = theme.dataset.themetitle;
      theme.style.display = themeTitle === title ? 'block' : 'none';
    });
  }

  // show first image on page load...
  if (features.length > 0) {
    if (window.innerWidth <= 991) {

      // mobile: open first accordion...
      const firstFeature = features[0];
      const firstAccordionImg = themeAccordionImages[0];
      const firstIconWrapper = accordionIconWrappers[0];
      const firstIconImg = firstIconWrapper?.querySelector('img');
      const minusImg = firstIconWrapper?.dataset.minusimg;
  
      // mark as active...
      firstFeature.classList.add('active');
      firstAccordionImg.classList.add('active');
  
      // change icon to minus...
      if (firstIconImg && minusImg) {
        firstIconImg.src = minusImg;
      }
    } else {
      features[0].classList.add('active');
      showImageForTheme(features[0].dataset.selectedtheme);
    }
  }

  // click event..
  features.forEach((feature, index) => {
    feature.addEventListener('click', function () {
      if(window.innerWidth <= 991){
        const currentImg = themeAccordionImages[index];
        const currentIconWrapper = accordionIconWrappers[index];
        const currentIconImg = currentIconWrapper?.querySelector('img');
        const minusImg = currentIconWrapper?.dataset.minusimg;
  
        const isActive = feature.classList.contains('active');
  
        // first close all..
        themeAccordionImages.forEach((img, i) => {
          // img.style.display = 'none';
          img.classList.remove('active');

          features[i].classList.remove('active');
  
          const iconImg = accordionIconWrappers[i]?.querySelector('img');
          const plusImg = accordionIconWrappers[i]?.dataset.plusimg;
          if (iconImg && plusImg) {
            iconImg.src = plusImg;
          }
        });
  
        // if it was NOT active, open it..
        if (!isActive) {
            if (currentImg) {
              // currentImg.style.display = 'block';
              currentImg.classList.add('active');
            }
            feature.classList.add('active');
            if (currentIconImg && minusImg) currentIconImg.src = minusImg;
        }
      }else{
        features.forEach(f => f.classList.remove('active'));
        this.classList.add('active');
  
        const selectedTheme = this.dataset.selectedtheme;
        showImageForTheme(selectedTheme); 
      }
    });
  });


// widgets slider..
jQuery('.grootapps_widgets-slider-wrapper').each(function(){
  jQuery(this).slick({
     draggable: false,
     infinite: true,
     autoplay: true,
     arrows: false,
     autoplaySpeed: 0,
     speed: 4000,
     pauseOnHover:false,
     slidesToShow: 4,
     cssEase: 'linear',
     vertical: false,
     responsive: [
         {
           breakpoint: 767,
           settings: {
             slidesToShow: 2,
           }
         },
         {
           breakpoint: 1200,
           settings: {
             slidesToShow: 3,
           }
         }
     ]
 });
})

// custom widgets JS...
  const custom_widgets = document.querySelectorAll('.grootapps_cw-options-list');
  const customWidgetsImages = document.querySelectorAll('.grootapps_cw-image');
  const customAccordionImages = document.querySelectorAll('.grootapps-cw-accordion-image');
  const customAccordionIconWrappers = document.querySelectorAll('.grootapps_cw-acoordion-icon-wrap');

  function showImageForCustomWidgets(title) {
    if (!customWidgetsImages || customWidgetsImages.length === 0) return;

    customWidgetsImages.forEach(image => {
      const widgetTitle = image.dataset.widgettitle;
      image.style.display = widgetTitle === title ? 'flex' : 'none';
    });
  }

  // show first image on page load...
  if (custom_widgets.length > 0) {
    if (window.innerWidth <= 991) {
      const firstWidget = custom_widgets[0];
      const firstAccordionImg = customAccordionImages[0];
      const firstIconWrapper = customAccordionIconWrappers[0];
      const firstIconImg = firstIconWrapper?.querySelector('img');
      const minusImg = firstIconWrapper?.dataset.minusimg;
  
      firstWidget.classList.add('active');
      firstAccordionImg.classList.add('active');
  
      if (firstIconImg && minusImg) {
        firstIconImg.src = minusImg;
      }
    } else {
      custom_widgets[0].classList.add('active');
      showImageForCustomWidgets(custom_widgets[0].dataset.selectedoption);
    }
  }

  // click event..
  custom_widgets.forEach((widgets, index) => {
    widgets.addEventListener('click', function () {
      if(window.innerWidth <= 991){
        const currentCustomImg = customAccordionImages[index];
        const currentCustomIconWrapper = customAccordionIconWrappers[index];
        const currentCustomIconImg = currentCustomIconWrapper?.querySelector('img');
        const minusImg = currentCustomIconWrapper?.dataset.minusimg;
  
        const isActive = widgets.classList.contains('active');
  
        // first close all..
        customAccordionImages.forEach((img, i) => {
          // img.style.display = 'none';
          img.classList.remove('active');
          custom_widgets[i].classList.remove('active');
  
          const iconImg = customAccordionIconWrappers[i]?.querySelector('img');
          const plusImg = customAccordionIconWrappers[i]?.dataset.plusimg;
          if (iconImg && plusImg) {
            iconImg.src = plusImg;
          }
        });
  
        // if it was NOT active, open it..
        if (!isActive) {
            if (currentCustomImg) currentCustomImg.classList.add('active');
            widgets.classList.add('active');
            if (currentCustomIconImg && minusImg) currentCustomIconImg.src = minusImg;
        }
      }else{
        custom_widgets.forEach(f => f.classList.remove('active'));
        this.classList.add('active');
        
        const selectedOption = this.dataset.selectedoption;
        showImageForCustomWidgets(selectedOption);
      }
    });
  });


// footer accordion js...
const menuAccordion = document.querySelectorAll(".gapp_footer-menu-heading");

if(window.innerWidth <= 991){
  if (menuAccordion.length > 0){
  
    // Hide all footer content on load...
    document.querySelectorAll(".footer-block__details-content").forEach((content) => {
      content.style.maxHeight = "0px";
      content.classList.remove("active");
    });
  
    menuAccordion.forEach((menu) => {
      menu.addEventListener("click", () => {
        const parent = menu.closest(".footer-block"); 
        const content = parent.querySelector(".footer-block__details-content");
        const img = menu.querySelector("img");
    
        // Close all other accordions...
        document.querySelectorAll(".footer-block__details-content").forEach((c) => {
          if (c !== content) {
              c.classList.remove("active");
              c.style.maxHeight = "0px";
              const accordionBtn = c.closest(".footer-block").querySelector(".gapp_footer-menu-heading");
              accordionBtn.querySelector("img").setAttribute("src", accordionBtn.dataset.plusimg);
          }
        });
    
        // Toggle current...
        content.classList.toggle("active");
    
        if (content.classList.contains("active")) {
          content.style.maxHeight = content.scrollHeight + 'px';
          img.setAttribute("src", menu.dataset.minusimg);
        } else {
          content.style.maxHeight = "0px";
          img.setAttribute("src", menu.dataset.plusimg);
        }
      });
    });
  }
}